import config from 'Cloud/config';
import classNames from 'clsx';
import React, { memo, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { updateViewerAttachesWorm } from 'reactApp/appHelpers/appHelpers';
import { useShowAdsBannerTimer } from 'reactApp/hooks/useShowAdsBannerTimer';
import { getFeatureAbAttachesExpId } from 'reactApp/modules/features/features.selectors';

import styles from './ReactViewer.css';

const DOM_ID_VIEWER_NEW_WORM = config.get('DOM_ID_VIEWER_NEW_WORM');

export const AttachesBanner = memo(({ adsUpdateTimerMs }: { adsUpdateTimerMs: number }): ReactElement | null => {
    const expId = useSelector(getFeatureAbAttachesExpId) || 327;

    return useShowAdsBannerTimer({
        adsUpdateTimerMs,
        updateAds: () => updateViewerAttachesWorm(expId),
        renderItem: () => (
            <div
                className={classNames(styles.attachesBanner, { [styles.attachesBanner_new]: expId === 428 })}
                id={DOM_ID_VIEWER_NEW_WORM}
            />
        ),
    });
});

AttachesBanner.displayName = 'AttachesBanner';

AttachesBanner.whyDidYouRender = true;
